import React from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const BASES = [
  { label: 'Usuários', endpoint: 'usuarios' },
  { label: 'Perfis', endpoint: 'perfis' },
  { label: 'Menu Itens', endpoint: 'menu_itens' },
  { label: 'Perfil Permissões', endpoint: 'perfil_permissoes' },
  { label: 'Recursos', endpoint: 'recursos' },
  { label: 'Ações', endpoint: 'acoes' },
  { label: 'Permissões Detalhadas', endpoint: 'perfil_permissoes_detalhadas' },
  { label: 'Alunos', endpoint: 'alunos' },
  { label: 'Usuário-Aluno', endpoint: 'usuario_aluno' },
  { label: 'Usuário-Equipe', endpoint: 'usuario_equipe' },
  { label: 'Equipe', endpoint: 'equipe' },
  { label: 'Modalidades', endpoint: 'modalidades' },
  { label: 'Turmas', endpoint: 'turmas' },
  { label: 'Matrículas', endpoint: 'matriculas' },
  { label: 'Unidades', endpoint: 'unidades' },
  { label: 'Tipo Unidades', endpoint: 'tipo_unidades' },
  { label: 'Tipo Contrato', endpoint: 'tipo_contrato' },
  { label: 'Séries', endpoint: 'series' },
  { label: 'Categorias Despesa', endpoint: 'categorias_despesa' },
  { label: 'Fornecedores', endpoint: 'fornecedores' },
  { label: 'Despesas', endpoint: 'despesas' },
  { label: 'Receitas', endpoint: 'receitas' },
  { label: 'Pagamentos', endpoint: 'folha_pagamento' },
  { label: 'Aulas Dadas', endpoint: 'aulas_dadas' },
];

const BasesPage = () => {
  const { user } = useAuth();
  const userRole = (user?.role || user?.perfil || '').toString().trim().toUpperCase();

  const handleDownload = async (endpoint) => {
    const response = await api.get(`/bases/${endpoint}/export`, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${endpoint}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleUpload = async (endpoint, file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      await api.post(`/bases/${endpoint}/import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Importação realizada com sucesso.');
    } catch (error) {
      alert(error.response?.data?.detail || 'Erro ao importar.');
    }
  };

  const handleFileChange = (endpoint, event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    handleUpload(endpoint, file);
    event.target.value = '';
  };

  if (userRole !== 'ADMIN') {
    return <div>Acesso restrito</div>;
  }

  return (
    <div>
      <h1>Bases de Dados</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px' }}>Base</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>Download</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>Upload</th>
          </tr>
        </thead>
        <tbody>
          {BASES.map((base) => (
            <tr key={base.endpoint}>
              <td style={{ padding: '8px' }}>{base.label}</td>
              <td style={{ padding: '8px' }}>
                <button type="button" onClick={() => handleDownload(base.endpoint)}>
                  Download
                </button>
              </td>
              <td style={{ padding: '8px' }}>
                <input
                  id={`upload-${base.endpoint}`}
                  type="file"
                  accept=".xlsx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFileChange(base.endpoint, event)}
                />
                <button
                  type="button"
                  onClick={() => {
                    const input = document.getElementById(`upload-${base.endpoint}`);
                    if (input) input.click();
                  }}
                >
                  Upload
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BasesPage;
